import { FC, useEffect, useMemo, useRef, useState } from "react";
// 组件
import { ProInputNumber } from '../antd';
// 方法
import classNames from "classnames";
// 常量
import { NumberIntervalProps, NumberIntervalValueType, inputNumberStyle } from "./interface";
import { TABLE_COLUMN_EMPTY } from "../constants/constant";
import './style.less';

/** 数字区间 */
const NumberInterval: FC<NumberIntervalProps> = props => {
  const { value: outValue, defauleValue, splitText, disabled, disabledRender, disabledBorder, disabledEllipsis, unit, onChange, } = props;
  const [value, setValue] = useState<NumberIntervalValueType[] | undefined>(defauleValue);
  const isFirstLoading = useRef<boolean>(true); // 是否首次加载
  useEffect(() => {
    if (!isFirstLoading.current || outValue) {
      setValue(outValue);
    }
    isFirstLoading.current = false;
  }, [outValue]);
  /** 开始值改变 */
  const handleStartChange = (value: any) => {
    setValue(prev => {
      const endValue = Array.isArray(prev) ? prev[1] : undefined;
      let newValue: NumberIntervalValueType[] | undefined = [value, endValue];
      if ((value === undefined || value === null) && (endValue === undefined || endValue === null)) {
        newValue = undefined;
      }
      onChange?.(newValue);
      return newValue;
    });
  };
  /** 结束值改变 */
  const handleEndChange = (value: any) => {
    setValue(prev => {
      const startValue = Array.isArray(prev) ? prev[0] : undefined;
      let newValue: NumberIntervalValueType[] | undefined = [startValue, value];
      if ((value === undefined || value === null) && (startValue === undefined || startValue === null)) {
        newValue = undefined;
      }
      onChange?.(newValue);
      return newValue;
    });
  };
  /** 禁用文字 */
  const disabledRenderHtml = () => {
    if (disabledRender) return disabledRender;
    let disabledText: string = '';
    if (Array.isArray(value) && value.length) {
      disabledText = value.map(item => item !== undefined ? `${item}${unit ?? ''}` : '').join(splitText || ' - ');
    }
    return disabledText || TABLE_COLUMN_EMPTY;
  };
  /** 禁用样式 */
  const disabledClasses = useMemo(() => {
    return classNames('yb-interval-type-disabled', {
      'border-bottom-dashed': disabledBorder,
      'yb-line-ellipsis-1': disabledEllipsis,
    });
  }, [disabledBorder, disabledEllipsis]);

  return (
    <>
      {
        disabled ? (
          <div className={disabledClasses}>
            {disabledRenderHtml()}
          </div>
        ) : (
          <div className="yb-number-interval">
            <div className="yb-number-interval-start">
              <ProInputNumber
                style={inputNumberStyle}
                value={Array.isArray(value) ? value[0] : undefined}
                company={unit}
                onChange={handleStartChange}
              />
            </div>
            <div className="yb-number-interval-split">
              {splitText}
            </div>
            <div className="yb-number-interval-end">
              <ProInputNumber
                style={inputNumberStyle}
                value={Array.isArray(value) ? value[1] : undefined}
                company={unit}
                onChange={handleEndChange}
              />
            </div>
          </div>
        )
      }
    </>
  );
};

NumberInterval.defaultProps = {
  splitText: '到',
};

export default NumberInterval;
